import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Tabs, { Tab } from "material-ui/Tabs";
import Table from "../../../../../components/table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { infoData, infoStdData, infoClassData } from "./infoenum";
import IPTab from "./ipTab";
import VLanTab from "./vlanTab";
import MacTab from "./macTab";
import InterfaceTab from "./interfaceTab";
import DiscoveryTab from "./discoveryTab";

class StatsResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabPosition: 0
    };
  }

  handleTabChange = (event, value, tab) => {
    let { tabPosition } = this.state;
    this.setState({ tabPosition: value });
  };

  render() {
    const {
      results,
      job,
      classes,
      result,
      subtest,
      subtestStatsResults,
      translate,
      chartMeasurementUnit
    } = this.props;
    let { tabPosition } = this.state;
    let signaltek10gDevice = job && job.deviceid === "signaltek10g"
    let haveMACStats = signaltek10gDevice || (subtestStatsResults != null && subtestStatsResults.mac !== null && subtestStatsResults.mac.length > 0);
    let haveVLANStats = signaltek10gDevice || (subtestStatsResults != null && subtestStatsResults.vlan !== null);
    let haveDiscoveryStats = signaltek10gDevice || (subtestStatsResults != null && subtestStatsResults.discovery !== null && subtestStatsResults.discovery.length > 0);
    let haveIPStats = signaltek10gDevice || (subtestStatsResults != null && subtestStatsResults.ip !== null);
    let hideLinkInfo = false;
    if (!signaltek10gDevice && results && results.data && results.data.fiberlengthloss) {
      if (this.state.tabPosition !== 3) {
        this.setState({ tabPosition: 3 });
      }
      hideLinkInfo = true;
    }

    return subtestStatsResults ? (
      <div ref="container">
        <Paper className={classes.paper}>
          {!signaltek10gDevice && !hideLinkInfo && (
          <Grid container className={classes.gridHeader}>
            <Grid item xs={1}></Grid>
              <Grid item xs={3} className={classes.totalGrid}>
                <Typography color="inherit" className={classes.defaultText}>
                  {translate("result_link_speed")}
                </Typography>
                <Typography color="inherit" className={classes.defaultText}>
                  {(subtestStatsResults.dhlinkspeed
                    ? subtestStatsResults.dhlinkspeed
                    : "- ")}
                </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_macadd")}
              </Typography>
              {subtestStatsResults.dhmacaddress && (
                <Typography color="inherit" className={classes.defaultText}>
                  {subtestStatsResults.dhmacaddress}
                </Typography>
              )}
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_ipv4")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestStatsResults.ipv4 ? subtestStatsResults.ipv4 : "-"}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGridLast}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_ipv6")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestStatsResults.ipv6 ? subtestStatsResults.ipv6 : "-"}
              </Typography>
            </Grid>
          </Grid>
          )}
          {signaltek10gDevice && (
          <Grid container className={classes.gridHeader}>
            <Grid item xs={1}></Grid>
            <Grid item xs={3} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_link_speed")}
              </Typography>
              {subtestStatsResults.rhlinkspeed &&
              subtestStatsResults.rhlinkspeed.length > 0 ? (
                <Typography color="inherit" className={classes.defaultText}>
                  {(subtestStatsResults.dhlinkspeed
                    ? subtestStatsResults.dhlinkspeed
                    : "- ") +
                    "(" +
                    translate("result_main") +
                    ")" +
                    " - " +
                    subtestStatsResults.rhlinkspeed +
                    "(" +
                    translate("result_remote") +
                    ")"}
                </Typography>
              ) : (
                <Typography color="inherit" className={classes.defaultText}>
                  {subtestStatsResults.dhlinkspeed
                    ? subtestStatsResults.dhlinkspeed +
                      "(" +
                      translate("result_main") +
                      ")"
                    : ""}
                </Typography>
              )}
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_macadd")}
              </Typography>
              {subtestStatsResults.dhmacaddress && (
                <Typography color="inherit" className={classes.defaultText}>
                  {subtestStatsResults.dhmacaddress}(
                  {translate("results_chart_display")})
                </Typography>
              )}
              {subtestStatsResults.rhmacaddress && (
                <Typography color="inherit" className={classes.defaultText}>
                  {subtestStatsResults.rhmacaddress}(
                  {translate("results_chart_remote")})
                </Typography>
              )}
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_ipv4")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestStatsResults.ipv4}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGridLast}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_ipv6")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestStatsResults.ipv6}
              </Typography>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          )}
          <Grid container className={classes.tabHeader}>
            <Grid item xs={12}>
              <Tabs
                value={tabPosition}
                onChange={this.handleTabChange}
                centered={true}
              >
                {haveIPStats && (
                <Tab
                  value={0}
                  label={translate("result_ip")}
                  className={classes.tab}
                />
                )}
                {haveVLANStats && (
                <Tab
                  value={1}
                  label={translate("result_vlan")}
                  className={classes.tab}
                />
                )}
                {haveMACStats && (
                <Tab
                  value={2}
                  label={translate("result_mac")}
                  className={classes.tab}
                />
                )}
                <Tab
                  value={3}
                  label={translate("result_interface")}
                  className={classes.tab}
                />
                {haveDiscoveryStats && (
                <Tab
                  value={4}
                  label={translate("result_discovery")}
                  className={classes.tab}
                />
                )}
              </Tabs>
            </Grid>
          </Grid>
          {tabPosition === 0 && subtestStatsResults.ip && (
            <Grid container>
              <Grid item xs={12}>
                <IPTab
                  subtestStatsResults={subtestStatsResults}
                  translate={translate}
                  hideDisclaimer={!signaltek10gDevice}
                />
              </Grid>
            </Grid>
          )}
          {tabPosition === 1 && subtestStatsResults.vlan && (
            <Grid container>
              <Grid item xs={12}>
                <VLanTab
                  subtestStatsResults={subtestStatsResults}
                  translate={translate}
                  hideDisclaimer={!signaltek10gDevice}
                />
              </Grid>
            </Grid>
          )}
          {tabPosition === 2 &&
            subtestStatsResults.mac &&
            subtestStatsResults.mac.length > 0 && (
              <Grid container>
                <Grid item xs={12}>
                  <MacTab
                    subtestStatsResults={subtestStatsResults}
                    translate={translate}
                    //temp={temp}
                  />
                </Grid>
              </Grid>
            )}
          {tabPosition === 3 &&
            subtestStatsResults.interfaces &&
            subtestStatsResults.interfaces.length > 0 && (
              <Grid container>
                <Grid item xs={12}>
                  <InterfaceTab
                    hideMainRemote={!signaltek10gDevice}
                    hideLinkStatus={!signaltek10gDevice}
                    subtestStatsResults={subtestStatsResults}
                    translate={translate}
                  />
                </Grid>
              </Grid>
            )}
          {tabPosition === 4 &&
            subtestStatsResults.discovery &&
            subtestStatsResults.discovery.length > 0 && (
              <Grid container>
                <Grid item xs={12}>
                  <DiscoveryTab
                    subtestStatsResults={subtestStatsResults}
                    translate={translate}
                    hideDisclaimer={!signaltek10gDevice}
                  />
                </Grid>
              </Grid>
            )}
        </Paper>
      </div>
    ) : (
      <Typography type="button">{translate("no_data_sg")}</Typography>
    );
  }
  componentWillMount() {
    const { getStatsResult, subtest, pager } = this.props;

    getStatsResult(pager.jid, pager.tid, subtest, null);
  }
  componentWillReceiveProps(nextProps) {
    const { getStatsResult, subtest, pager } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getStatsResult(pager.jid, pager.tid, subtest, null);
    }
  }
}

export default withStyles(styles)(StatsResult);



// WEBPACK FOOTER //
// ./src/components/common/results/views/stats/index.js